// extracted by mini-css-extract-plugin
export default {"container":"UnexpectedErrorPage_container__O-a4E","heading":"UnexpectedErrorPage_heading__YipLL"};